import { createContext, ReactNode } from 'react';

export interface FilterConfig {
  // Unique identifier for the filter set
  id: string;
  // Title shown in the filter panel
  title: string;
  // Content to render inside the filter
  content: ReactNode;
  // Number of active filters
  activeCount?: number;
  // Callback when filters are applied
  onApply?: () => void;
  // Callback when filters are reset
  onReset?: () => void;
  // Whether Apply button should be disabled
  isApplyDisabled?: boolean;
  // Whether Reset button should be disabled
  isResetDisabled?: boolean;
}

export interface HeaderSearchConfig {
  // Current search value
  value?: string;
  defaultValue?: string;
  // Placeholder text
  placeholder?: string;
  // Callback when search changes
  onChange: (value: string) => void;
  // Whether search is enabled
  enabled?: boolean;
}

export interface PathConfigs {
  [path: string]: {
    filterConfig: FilterConfig | null;
    searchConfig: HeaderSearchConfig | null;
  };
}

export interface HeaderFiltersContextValue {
  filterConfig: FilterConfig | null;
  searchConfig: HeaderSearchConfig | null;
  isFilterOpen: boolean;
  setFilterConfig: (config: FilterConfig | null) => void;
  setSearchConfig: (config: HeaderSearchConfig | null) => void;
  openFilters: () => void;
  closeFilters: () => void;
  toggleFilters: () => void;
}

export const HeaderFiltersContext = createContext<HeaderFiltersContextValue | null>(null);
